import { render, staticRenderFns, recyclableRender, components } from "./imagesingle.vue?vue&type=template&id=24ac7051&"
var renderjs
import script from "./imagesingle.vue?vue&type=script&lang=js&"
export * from "./imagesingle.vue?vue&type=script&lang=js&"
import style0 from "./imagesingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/diy/imagesingle/imagesingle.vue"
export default component.exports